/* Bazaar Bee Watch & Shop v2.2 (approved mockups/watch-shop-v2.html):
   gallery cards → full-screen player that works like Shorts / Reels:
   - the tapped video starts by itself with sound; swiping stops the old one and plays the next
   - tap = pause / play (photo stories: tap left / right for the previous / next photo), 🔊 button = sound on / off
   - if the browser blocks sound (iPhone), the video plays muted with a "Tap for sound" chip
   - mobile: real full screen (browser bars hidden) while open; Back button or ✕ closes it and brings the bars back
   - a product with more videos shows "▶ 3 more videos of this product": tap = only that product's videos,
     "← All videos" (or the Back button) returns to the mixed feed at the same video
   Product page mode (sections/bb-product-videos, data-bbw2-pdp): only that product's videos, no side rail,
   ORDER NOW closes the player and brings up the buy box; "▶ Watch N videos" pill on the main product photo.
   slim product bar → Quick buy sheet (packs, COD, checkout), add to cart, share links (?v=), category chips. */
(() => {
  if (window.BBW2) return;
  window.BBW2 = true;
  if (window.Shopify && Shopify.designMode) document.addEventListener('shopify:section:load', (e) => { if (e.target.querySelector('[data-bbw2]')) location.reload(); });
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const H = document.documentElement;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const inr = (c) => '₹' + Math.round(c / 100).toLocaleString('en-IN');
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const JSONH = { 'Content-Type': 'application/json', Accept: 'application/json' };
  const PH_MS = 3200;

  /* YouTube IFrame API (loaded once, early, so the first video can start right after the tap) */
  let ytReady = null;
  const loadYT = () => ytReady || (ytReady = new Promise((res) => {
    if (window.YT && YT.Player) return res();
    const prev = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => { if (prev) prev(); res(); };
    const sc = document.createElement('script'); sc.src = 'https://www.youtube.com/iframe_api'; sc.async = true; document.head.appendChild(sc);
  }));

  function init() {
    const sec = $('[data-bbw2]');
    if (!sec) return;
    const pdp = sec.hasAttribute('data-bbw2-pdp');
    let V = [], P = {};
    try { V = JSON.parse($('[data-bbw2-entries]', sec).textContent); } catch (e) {}
    try { P = JSON.parse($('[data-bbw2-products]', sec).textContent); } catch (e) {}
    Object.values(P).forEach((p) => { if (!Array.isArray(p.offs)) p.offs = []; });
    const days = +sec.dataset.etaDays || 7;
    const eta = () => { const d = new Date(); d.setDate(d.getDate() + days); return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }); };
    if (V.some((v) => v.k === 'yt')) {
      if (!pdp) setTimeout(loadYT, 600);
      else {
        if ('IntersectionObserver' in window) {
          const lo = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) { lo.disconnect(); loadYT(); } }, { rootMargin: '400px' });
          lo.observe(sec);
        }
        sec.addEventListener('pointerdown', loadYT, { once: true });
      }
    }

    /* chips stick right under the sticky header */
    const sticky = () => {
      // the header's sticky wrapper (Horizon: header.header-section around #header-component)
      let el = document.getElementById('header-component'), h = 0;
      while (el && el !== document.body) {
        const cs = getComputedStyle(el);
        if (cs.position === 'sticky' || cs.position === 'fixed') { h = Math.round(el.getBoundingClientRect().height + (parseFloat(cs.top) || 0)); break; }
        el = el.parentElement;
      }
      sec.style.setProperty('--bbw2-sticky', Math.max(0, h) + 'px');
    };
    sticky(); window.addEventListener('resize', sticky); window.addEventListener('load', sticky);

    /* toast */
    const toastEl = $('[data-bbw2-toast]', sec);
    let tt;
    const toast = (t) => { toastEl.textContent = t; toastEl.classList.add('is-on'); clearTimeout(tt); tt = setTimeout(() => toastEl.classList.remove('is-on'), 1900); };

    /* cart */
    async function add(variant, qty) {
      const r = await fetch(`${root}cart/add.js`, { method: 'POST', headers: JSONH, body: JSON.stringify({ items: [{ id: variant, quantity: qty || 1 }] }) });
      if (!r.ok) throw new Error(String(r.status));
      if (document.getElementById('bb-cart-drawer')) document.dispatchEvent(new CustomEvent('bb:cart:added'));
      else toast('✓ Added to cart');
    }
    async function setQty(variant, qty) {
      const c = await (await fetch(`${root}cart.js`)).json();
      const line = c.items.find((i) => String(i.variant_id) === String(variant));
      const r = line
        ? await fetch(`${root}cart/update.js`, { method: 'POST', headers: JSONH, body: JSON.stringify({ updates: { [variant]: qty } }) })
        : await fetch(`${root}cart/add.js`, { method: 'POST', headers: JSONH, body: JSON.stringify({ items: [{ id: variant, quantity: qty }] }) });
      if (!r.ok) throw new Error(String(r.status));
    }

    /* chips */
    let filter = 'all';
    const setChip = (k) => {
      filter = k;
      $$('[data-bbw2-chip]', sec).forEach((b) => b.classList.toggle('is-on', b.dataset.bbw2Chip === k));
      const tr = $('[data-bbw2-trending]', sec); if (tr) tr.hidden = k !== 'all';
      $$('.bbw2-cat', sec).forEach((s) => (s.hidden = k !== 'all' && s.dataset.cat !== k));
      const on = $('[data-bbw2-chip].is-on', sec), bar = on && on.parentElement;
      if (bar) bar.scrollTo({ left: on.offsetLeft - (bar.clientWidth - on.clientWidth) / 2, behavior: 'smooth' });
      const a = $('[data-bbw2-anchor]', sec); if (a) a.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    /* ---------- player ---------- */
    const pl = $('[data-bbw2-pl]', sec), feed = $('[data-bbw2-feed]', sec);
    let list = [], io = null, lastFocus = null, active = null, settleUntil = 0;
    let ctrls = new Map();
    let muted = false;
    try { muted = sessionStorage.getItem('bbw2_muted') === '1'; } catch (e) {}
    let policyMuted = false; // the browser refused sound without a tap (iPhone): playing muted until the next tap
    let mode = 'mix', lastCat = null, backTo = -1; // 'product' = only one product's videos
    const isVidE = (v) => v.k !== 'photos';
    const nvOf = (h) => V.filter((v) => v.p === h && isVidE(v)).length;

    const slides = () => $$('[data-bbw2-sl]', feed);
    const entryOf = (s) => { const i = slides().indexOf(s); return i > -1 ? list[i][0] : null; };
    const soundIcons = () => {
      const off = muted || policyMuted;
      $$('[data-bbw2-snd]', pl).forEach((b) => { b.textContent = off ? '🔇' : '🔊'; b.setAttribute('aria-label', off ? 'Sound on' : 'Sound off'); });
      pl.classList.toggle('is-policy-muted', policyMuted && !muted);
    };

    const slide = (v, n, total, j) => {
      const p = P[v.p] || {};
      let media = '';
      if (v.k === 'yt') media = `<div class="bbw2-ytp"></div><img class="bbw2-poster" src="https://i.ytimg.com/vi/${esc(v.id)}/oar2.jpg" alt="" onerror="this.onerror=null;this.src='https://i.ytimg.com/vi/${esc(v.id)}/hqdefault.jpg'">`;
      else if (v.k === 'video') media = `<div class="bbw2-vbox"></div>${v.poster ? `<img class="bbw2-poster" src="${esc(v.poster)}" alt="">` : ''}`;
      else media = `<img class="bbw2-bg" src="${esc(v.bg)}" alt="">` + v.ph.map(([u, a], k) => `<figure${k ? '' : ' class="is-on"'}><img src="${esc(u)}" alt="${esc(a)}"${k > 1 ? ' loading="lazy"' : ''}></figure>`).join('');
      const isVid = v.k !== 'photos';
      const bars = isVid ? '' : `<div class="bbw2-bars">${v.ph.map(() => '<i><b></b></i>').join('')}</div>`;
      const cr = isVid ? (v.by ? `<span class="bbw2-cr">🎥 ${esc(v.by)}</span>` : '') : '<span class="bbw2-cr">📸 Photo story</span>';
      const cap = isVid ? v.cap : v.ph[0][1];
      const pm = mode === 'product', nv = isVid && !pm && !pdp ? nvOf(v.p) : 0;
      const snd = isVid ? '<button type="button" class="bbw2-snd" data-bbw2-snd aria-label="Sound off">🔊</button>' : '';
      const top = pm
        ? `<div class="bbw2-top"><button type="button" class="bbw2-back" data-bbw2-back>← All videos</button><span class="bbw2-ct">${n} / ${total}</span>${snd}</div><div class="bbw2-pmode">🎬 All videos of this product${v.by ? ` • 🎥 ${esc(v.by)}` : ''}</div>`
        : `<div class="bbw2-top"><span class="bbw2-ct">${n} / ${total}</span>${cr}${snd}</div>`;
      const more = nv > 1 ? `<button type="button" class="bbw2-more-v" data-bbw2-more>▶ ${nv - 1} more video${nv > 2 ? 's' : ''} of this product <i>${nv}</i></button>` : '';
      return `<section class="bbw2-sl${isVid ? ' bbw2-sl--vid' : ''}${pm ? ' bbw2-sl--pm' : ''}" data-bbw2-sl data-p="${esc(v.p)}" data-j="${j}">${media}${bars}
        ${isVid ? '<span class="bbw2-bigplay" aria-hidden="true">▶</span><button type="button" class="bbw2-unmute" data-bbw2-snd-on>🔇 Tap for sound</button>' : ''}
        ${top}
        <div class="bbw2-scap" data-bbw2-scap><span>${esc(cap)}</span><small>${isVid ? 'Tap to pause • Swipe up for next' : 'Tap left/right for photos'}</small>${more}</div>
        ${pdp ? '' : `<div class="bbw2-rail"><button type="button" data-bbw2-add="${esc(v.p)}"><i>🛒</i>Add</button><button type="button" data-bbw2-share><i>🔗</i>Share</button><a href="${esc(p.url || '#')}"><i>📄</i>Details</a></div>`}
        <div class="bbw2-pbar"><button type="button" class="bbw2-pi" data-bbw2-order aria-label="Product details and order">${p.img ? `<img src="${esc(p.img)}" alt="" width="42" height="42">` : '<span></span>'}<span><span class="bbw2-t">${esc(p.title)}</span><span class="bbw2-p">${p.price != null ? inr(p.price) : ''}${p.badge ? `<span class="bbw2-b">${esc(p.badge)}</span>` : ''}<small>COD</small></span></span></button>
          ${pdp && !p.avail ? '<button type="button" class="bbw2-go" disabled>SOLD OUT</button>' : `<button type="button" class="bbw2-go" data-bbw2-order>${pdp ? 'ORDER NOW' : 'ORDER ➜'}<small>Cash on Delivery</small></button>`}</div>
      </section>`;
    };

    /* one controller per slide: play / pause / mute / prep / destroy */
    const ytCtrl = (s, v) => {
      let yp = null, ready = false, want = false, making = false, guard = 0, dead = false;
      const make = async () => {
        if (yp || making) return; making = true;
        await loadYT();
        if (dead || !s.isConnected) return;
        const host = document.createElement('div'); $('.bbw2-ytp', s).appendChild(host);
        yp = new YT.Player(host, {
          host: 'https://www.youtube-nocookie.com', videoId: v.id, width: '100%', height: '100%',
          playerVars: { autoplay: 0, controls: 0, playsinline: 1, rel: 0, modestbranding: 1, iv_load_policy: 3, loop: 1, playlist: v.id, fs: 0, disablekb: 1, cc_load_policy: 0, origin: location.origin },
          events: {
            onReady: () => { ready = true; if (want) start(); },
            onStateChange: (e) => {
              if (e.data === 1) { clearTimeout(guard); clearTimeout(s._pt); s._pt = setTimeout(() => s.classList.add('is-playing'), 250); s.classList.remove('is-paused'); }
              else { clearTimeout(s._pt); if (e.data !== 3) s.classList.remove('is-playing'); }
              if (e.data === 2 && want && !document.hidden && !s.dataset.userPaused) setTimeout(() => { if (want && ready) yp.playVideo(); }, 300);
            },
          },
        });
      };
      const start = () => {
        if (muted || policyMuted) yp.mute(); else yp.unMute();
        yp.playVideo();
        clearTimeout(guard);
        // sound refused? (YouTube stays unstarted / paused) → play muted and show "Tap for sound"
        let tries = 0;
        const check = () => {
          if (!want || !ready || muted || !yp) return;
          const st = yp.getPlayerState();
          if (st === 1) return;
          if (st === 3 && tries++ < 4) { guard = setTimeout(check, 1200); return; } // buffering: wait, sound was allowed
          policyMuted = true; soundIcons(); yp.mute(); yp.playVideo();
        };
        guard = setTimeout(check, 1800);
      };
      return {
        play: () => { want = true; delete s.dataset.userPaused; make(); if (ready) start(); },
        pause: () => { want = false; clearTimeout(guard); if (ready) yp.pauseVideo(); },
        mute: (m) => { if (ready) (m ? yp.mute() : yp.unMute()); },
        prep: () => { make(); },
        paused: () => !want || !ready || yp.getPlayerState() !== 1,
        destroy: () => { dead = true; want = false; clearTimeout(guard); try { if (yp && yp.destroy) yp.destroy(); } catch (e) {} yp = null; ready = false; },
      };
    };
    const vidCtrl = (s, v) => {
      let el = null, want = false;
      const make = () => {
        if (el || !v.src) return el;
        el = document.createElement('video');
        el.src = v.src; el.loop = true; el.playsInline = true; el.setAttribute('playsinline', ''); el.preload = 'metadata'; if (v.poster) el.poster = v.poster;
        el.addEventListener('playing', () => { s.classList.add('is-playing'); s.classList.remove('is-paused'); });
        el.addEventListener('pause', () => s.classList.remove('is-playing'));
        $('.bbw2-vbox', s).appendChild(el);
        return el;
      };
      return {
        play: () => {
          want = true; delete s.dataset.userPaused; if (!make()) return;
          el.muted = muted || policyMuted;
          el.play().catch(() => { if (!want) return; policyMuted = true; soundIcons(); el.muted = true; el.play().catch(() => s.classList.add('is-paused')); });
        },
        pause: () => { want = false; if (el) el.pause(); },
        mute: (m) => { if (el) el.muted = m; },
        prep: () => { if (make()) el.preload = 'auto'; },
        paused: () => !el || el.paused,
        destroy: () => { want = false; if (el) { el.pause(); el.removeAttribute('src'); el.load(); el.remove(); } el = null; },
      };
    };
    const photoCtrl = (s, v) => {
      const figs = $$('figure', s), bars = $$('.bbw2-bars i', s), cap = $('[data-bbw2-scap] span', s);
      let k = 0, timer = 0, on = false;
      const show = (n) => {
        k = (n + figs.length) % figs.length;
        figs.forEach((f, j) => f.classList.toggle('is-on', j === k));
        bars.forEach((b, j) => { b.className = j < k ? 'is-done' : j === k ? 'is-now' : ''; const x = b.firstChild; x.style.animation = 'none'; void x.offsetWidth; x.style.animation = ''; });
        if (cap) cap.textContent = v.ph[k][1];
        const nx = figs[(k + 1) % figs.length]; const im = nx && $('img', nx); if (im) im.loading = 'eager';
      };
      const run = () => { clearInterval(timer); timer = setInterval(() => show(k + 1), PH_MS); };
      return {
        play: () => { on = true; show(on && k ? k : 0); run(); },
        pause: () => { on = false; clearInterval(timer); },
        mute: () => {}, prep: () => {}, paused: () => !on,
        step: (d) => { show(k + d); if (on) run(); },
        destroy: () => { on = false; clearInterval(timer); },
      };
    };
    const ctrl = (s) => {
      if (ctrls.has(s)) return ctrls.get(s);
      const v = entryOf(s); if (!v) return null;
      const c = v.k === 'yt' ? ytCtrl(s, v) : v.k === 'video' ? vidCtrl(s, v) : photoCtrl(s, v);
      ctrls.set(s, c);
      return c;
    };
    const activate = (s) => {
      if (!s || active === s) return;
      if (active) { const c = ctrls.get(active); if (c) c.pause(); active.classList.remove('is-paused'); }
      active = s;
      const c = ctrl(s); if (c) c.play();
      const all = slides(), i = all.indexOf(s);
      all.forEach((x) => { x.inert = x !== s; });
      const fa = document.activeElement, fs = fa && fa.closest && fa.closest('[data-bbw2-sl]');
      if (fs && fs !== s) feed.focus({ preventScroll: true });
      [all[i + 1], all[i - 1]].forEach((n) => { if (n) { const nc = ctrl(n); if (nc) nc.prep(); } });
      // free far-away players (keeps memory low on long feeds)
      ctrls.forEach((cc, ss) => { const j = all.indexOf(ss); if (Math.abs(j - i) > 2) { cc.destroy(); ctrls.delete(ss); ss.classList.remove('is-playing', 'is-paused'); } });
    };
    const togglePause = (s) => {
      const c = ctrls.get(s); if (!c) return;
      // first tap on a video the browser started muted = turn the sound on (keep playing)
      if (policyMuted && !muted && !c.paused()) { policyMuted = false; soundIcons(); c.mute(false); return; }
      if (c.paused()) { delete s.dataset.userPaused; s.classList.remove('is-paused'); c.play(); }
      else { s.dataset.userPaused = '1'; c.pause(); s.classList.add('is-paused'); }
    };
    const setMuted = (m) => {
      muted = m; policyMuted = false;
      try { sessionStorage.setItem('bbw2_muted', m ? '1' : '0'); } catch (e) {}
      ctrls.forEach((c) => c.mute(m));
      if (!m && active) { const c = ctrls.get(active); if (c && c.paused() && !active.dataset.userPaused) c.play(); }
      soundIcons();
    };

    /* full screen on phones (Android Chrome & co.; iPhone Safari has no page full screen) */
    const phone = () => matchMedia('(max-width: 899px)').matches;
    let wentFS = false;
    const enterFS = () => {
      if (!phone() || document.fullscreenElement) return;
      const el = H, req = el.requestFullscreen || el.webkitRequestFullscreen;
      if (!req) return;
      try {
        const r = req.call(el, { navigationUI: 'hide' }); wentFS = true;
        if (r && r.then) r.then(() => { if (!pl.classList.contains('is-on')) { wentFS = false; const ex = document.exitFullscreen || document.webkitExitFullscreen; if (ex) { try { const x = ex.call(document); if (x && x.catch) x.catch(() => {}); } catch (er) {} } } }, () => { wentFS = false; });
      } catch (e) { wentFS = false; }
    };
    const exitFS = () => {
      if (!wentFS) return; wentFS = false;
      const d = document; if (d.fullscreenElement || d.webkitFullscreenElement) { const ex = d.exitFullscreen || d.webkitExitFullscreen; if (ex) { try { const r = ex.call(d); if (r && r.catch) r.catch(() => {}); } catch (e) {} } }
    };
    const onFS = () => {
      if (document.fullscreenElement || document.webkitFullscreenElement || !wentFS) return;
      wentFS = false;
      if (!pl.classList.contains('is-on')) return;
      if (mode !== 'product') return close();
      // Android Back while watching one product's videos: leave full screen, back to all videos
      closeQ();
      if (pmPushed) { pmPushed = false; skipPop = true; history.back(); }
      backToAll();
    };
    document.addEventListener('fullscreenchange', onFS);
    document.addEventListener('webkitfullscreenchange', onFS);

    /* phone Back button: product mode → all videos; otherwise closes the player */
    let pushed = false, pmPushed = false, skipPop = false;
    window.addEventListener('popstate', (e) => {
      if (skipPop) { skipPop = false; return; } // our own history.back() after "← All videos"
      const st = (e.state && e.state.bbw2) || 0, depth = pushed ? (pmPushed ? 2 : 1) : 0;
      if (st > depth) { skipPop = true; history.go(depth - st); return; } // Forward into an entry already left: step back out
      if (st === depth) return;
      const on = pl.classList.contains('is-on');
      closeQ();
      if (st === 1) { pmPushed = false; if (on && mode === 'product') backToAll(); return; }
      pushed = false; pmPushed = false;
      if (on) close(true);
    });

    // mix products: each product's 1st video/story, then each product's 2nd, … (a product with 10 videos never fills the feed)
    const mixed = (onlyCat) => {
      const groups = new Map(), out = [];
      V.forEach((v, j) => { if (onlyCat ? v.c !== onlyCat : filter !== 'all' && v.c !== filter) return; if (!groups.has(v.p)) groups.set(v.p, []); groups.get(v.p).push([v, j]); });
      for (let r = 0, more = true; more; r++) { more = false; groups.forEach((g) => { if (g[r]) { out.push(g[r]); more = true; } }); }
      return out;
    };
    // (re)fill the feed and start at entry i
    const build = (lst, i, settle) => {
      if (io) io.disconnect();
      ctrls.forEach((c) => c.destroy());
      list = lst;
      feed.innerHTML = list.map(([v, j], n) => slide(v, n + 1, list.length, j)).join('');
      ctrls = new Map(); active = null;
      const start = Math.max(0, list.findIndex(([, j]) => j === i));
      feed.scrollTop = start * feed.clientHeight;
      activate(slides()[start]); // play right away (sound allowed: this runs from the tap)
      settleUntil = settle && wentFS ? Date.now() + 900 : 0; // while full screen kicks in the feed resizes: keep the tapped video
      io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting && e.intersectionRatio >= 0.6 && Date.now() > settleUntil) activate(e.target); }), { root: feed, threshold: 0.6 });
      if (settleUntil) setTimeout(realign, 950);
      slides().forEach((s) => io.observe(s));
      feed.focus({ preventScroll: true });
    };
    const livePdp = () => {
      const cta = $('.bb-cta[data-order]:not(.bb-cta--sm)'), pr = $('.bb-price__now[data-price-now]');
      Object.values(P).forEach((p) => {
        if (cta) p.avail = !cta.disabled;
        const n = pr ? parseFloat(pr.textContent.replace(/[^\d.]/g, '')) : 0;
        if (n > 0) p.price = Math.round(n * 100);
      });
    };
    const open = (i, onlyCat) => {
      const lst = mixed(onlyCat);
      if (!lst.length) return;
      if (pdp) livePdp();
      mode = 'mix'; lastCat = onlyCat; pmPushed = false;
      policyMuted = false;
      enterFS(); // first, while the tap still counts as a user gesture
      lastFocus = document.activeElement;
      pl.classList.add('is-on'); H.classList.add('bbw2-open');
      soundIcons();
      try {
        const u = new URL(location.href);
        if (u.searchParams.has('v')) { u.searchParams.delete('v'); history.replaceState(history.state, '', u); }
        history.pushState({ bbw2: 1 }, ''); pushed = true;
      } catch (e) {}
      build(lst, i, true);
    };
    // "▶ 3 more videos of this product": that product's videos only, starting with the next one
    const openProduct = (s) => {
      const fromJ = +s.dataset.j, h = s.dataset.p;
      const vids = V.map((v, j) => [v, j]).filter(([v]) => v.p === h && isVidE(v));
      if (vids.length < 2) return;
      const k = vids.findIndex(([, j]) => j === fromJ);
      backTo = fromJ; mode = 'product';
      policyMuted = false; soundIcons();
      if (pushed && !pmPushed) { try { history.pushState({ bbw2: 2 }, ''); pmPushed = true; } catch (e) {} }
      build(vids, vids[(k + 1) % vids.length][1]);
    };
    const backToAll = () => {
      mode = 'mix';
      const lst = mixed(lastCat);
      if (!lst.length) return close();
      build(lst, backTo);
    };
    function close(fromBack) {
      closeQ();
      if (io) io.disconnect();
      ctrls.forEach((c) => c.destroy()); ctrls = new Map(); active = null;
      pl.classList.remove('is-on', 'is-policy-muted'); H.classList.remove('bbw2-open');
      feed.innerHTML = '';
      exitFS();
      mode = 'mix';
      if (!fromBack && pushed) { const n = pmPushed ? 2 : 1; pushed = false; history.go(-n); }
      pmPushed = false;
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    document.addEventListener('visibilitychange', () => {
      if (!active) return;
      const c = ctrls.get(active); if (!c) return;
      if (document.hidden) c.pause(); else if (!active.dataset.userPaused) c.play();
    });

    /* quick buy */
    let qh = null, qn = 1;
    const packs = (p) => [{ n: 1, total: p.price, off: 0 }].concat(p.offs.map((off, i) => ({ n: i + 2, total: p.price * (i + 2) - off * 100, off })));
    const renderQ = () => {
      const p = P[qh]; if (!p) return;
      const ks = packs(p), k = ks.find((x) => x.n === qn) || ks[0];
      $('[data-bbw2-q-p]', sec).textContent = inr(k.total);
      $('[data-bbw2-q-p2]', sec).textContent = inr(k.total);
      $('[data-bbw2-q-packs]', sec).innerHTML = ks.length > 1 && !p.multi ? ks.map((x) => `<button type="button" data-bbw2-pack="${x.n}"${x.n === k.n ? ' class="is-on"' : ''}>${x.off ? `<span class="bbw2-sv">SAVE ₹${x.off}</span>` : ''}${x.n} Pack${x.n > 1 ? 's' : ''}<b>${inr(x.total)}</b></button>`).join('') : '';
    };
    const openQ = (h) => {
      const p = P[h]; if (!p) return;
      if (p.multi) { location.href = p.url; return; }
      qh = h; qn = 1;
      const img = $('[data-bbw2-q-img]', sec); img.src = p.img || ''; img.style.visibility = p.img ? '' : 'hidden';
      $('[data-bbw2-q-t]', sec).textContent = p.title;
      $('[data-bbw2-q-url]', sec).href = p.url;
      $('[data-bbw2-eta]', sec).textContent = eta();
      $('[data-bbw2-place]', sec).disabled = !p.avail;
      renderQ();
      H.classList.add('bbw2-qb');
    };
    const closeQ = () => H.classList.remove('bbw2-qb');
    const toBuyBox = () => {
      close();
      const b = $('.bb-cta[data-order]:not(.bb-cta--sm)');
      if (!b || b.disabled) return;
      b.focus({ preventScroll: true });
      setTimeout(() => { // after the player's history entry is gone (the theme restores scroll on popstate)
        b.scrollIntoView({ behavior: 'smooth', block: 'center' });
        b.classList.remove('bbw2-flash'); void b.offsetWidth; b.classList.add('bbw2-flash');
        setTimeout(() => b.classList.remove('bbw2-flash'), 2600);
      }, 350);
    };

    /* product page: "▶ Watch N videos" pill on the main product photo */
    if (pdp && sec.hasAttribute('data-bbw2-pill')) {
      const nvid = V.filter(isVidE).length;
      const addPill = () => {
        const box = $$('media-gallery slideshow-container').find((x) => !x.closest('dialog, zoom-dialog'));
        if (!box || !nvid || $('.bbw2-vpill', box)) return;
        const th = sec.dataset.bbw2Pill;
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'bbw2-vpill';
        b.innerHTML = `${th ? `<img src="${esc(th)}" alt="" width="34" height="34">` : ''}▶ Watch <i>${nvid} video${nvid > 1 ? 's' : ''}</i>`;
        b.addEventListener('pointerdown', loadYT, { once: true });
        b.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); open(0, null); });
        box.appendChild(b);
      };
      addPill();
      const main = $('main') || document.body;
      let queued = false;
      new MutationObserver(() => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; addPill(); }); }).observe(main, { childList: true, subtree: true });
    }
    /* product page: the gallery's own video slides open this player too (assets/bb-pdp-video.js asks first) */
    if (pdp) {
      const vkey = (u) => { const m = String(u || '').match(/\/vp\/([\w-]+)\//) || String(u || '').match(/([^/?#]+)\.(?:mp4|m3u8|webm)/i); return m ? m[1] : ''; };
      window.BBW2open = (src) => {
        let i = -1;
        if (src && src.yt) i = V.findIndex((v) => v.k === 'yt' && v.id === src.yt);
        else if (src && src.video) {
          const el = src.video;
          const keys = [el.getAttribute('src'), ...[...el.querySelectorAll('source')].map((x) => x.getAttribute('src'))].map(vkey).filter(Boolean);
          i = V.findIndex((v) => v.k === 'video' && keys.includes(vkey(v.src)));
        }
        if (i < 0) return false;
        open(i, null);
        return true;
      };
    }

    /* deep link ?v= (no tap yet, so the browser may start it muted) */
    const want = new URLSearchParams(location.search).get('v');
    if (want) { const i = V.findIndex((v) => v.v === want); if (i > -1) requestAnimationFrame(() => open(i, null)); }

    sec.addEventListener('click', async (e) => {
      const t = e.target;
      const ch = t.closest('[data-bbw2-chip]'); if (ch) return setChip(ch.dataset.bbw2Chip);
      const wa = t.closest('[data-bbw2-watchall]'); if (wa) { e.preventDefault(); return open(V.findIndex((v) => v.k !== 'photos'), null); }
      const pc = t.closest('[data-bbw2-playcat]'); if (pc) { e.preventDefault(); const c = pc.dataset.bbw2Playcat; return open(V.findIndex((v) => v.c === c), c); }
      const op = t.closest('[data-open]'); if (op) return open(+op.dataset.open, null);
      if (t.closest('[data-bbw2-qclose]')) return closeQ();
      const pk = t.closest('[data-bbw2-pack]'); if (pk) { qn = +pk.dataset.bbw2Pack; return renderQ(); }
      const place = t.closest('[data-bbw2-place]');
      if (place && qh) {
        place.disabled = true;
        try { await setQty(P[qh].variant, qn); exitFS(); if (window.bbCheckout) { place.disabled = false; closeQ(); window.bbCheckout(); } else location.href = `${root}checkout`; } // bbCheckout: our COD form
        catch (er) { place.disabled = false; toast('Sorry, please try again'); }
        return;
      }
      if (t.closest('[data-bbw2-close]')) return close();
      const mo = t.closest('[data-bbw2-more]'); if (mo) return openProduct(mo.closest('[data-bbw2-sl]'));
      // switch right away (keeps the tap's sound permission), then drop the history entry product mode added
      if (t.closest('[data-bbw2-back]')) { if (pmPushed) { pmPushed = false; skipPop = true; history.back(); } policyMuted = false; soundIcons(); return backToAll(); }
      if (t.closest('[data-bbw2-snd]')) return setMuted(!(muted || policyMuted));
      if (t.closest('[data-bbw2-snd-on]')) return setMuted(false);
      const ord = t.closest('[data-bbw2-order]'); if (ord && pdp) return toBuyBox();
      if (ord) { const s = ord.closest('[data-bbw2-sl]'); const c = ctrls.get(s); if (c && !c.paused()) { c.pause(); s.dataset.userPaused = '1'; s.classList.add('is-paused'); } return openQ(s.dataset.p); }
      const ad = t.closest('[data-add], [data-bbw2-add]');
      if (ad) {
        const h = ad.dataset.add || ad.dataset.bbw2Add, p = P[h];
        if (!p) return;
        if (p.multi || !p.avail) { location.href = p.url; return; }
        ad.disabled = true;
        try {
          await add(p.variant, 1);
          if (ad.classList.contains('bbw2-add')) { ad.classList.add('is-done'); ad.textContent = '✓'; } else ad.classList.add('is-done');
          if (pl.classList.contains('is-on')) toast('✓ Added to cart');
        } catch (er) { toast('Sorry, please try again'); }
        ad.disabled = false;
        return;
      }
      if (t.closest('[data-bbw2-share]')) {
        const v = active && entryOf(active); if (!v) return;
        const u = new URL(location.href); u.searchParams.set('v', v.v); u.hash = '';
        if (navigator.share) { navigator.share({ title: document.title, url: u.toString() }).catch(() => {}); return; }
        try { await navigator.clipboard.writeText(u.toString()); toast('🔗 Link to this video copied'); } catch (er) { prompt('Copy this link', u.toString()); }
        return;
      }
      if (t.closest('[data-bbw2-prev]')) return feed.scrollBy({ top: -feed.clientHeight, behavior: 'smooth' });
      if (t.closest('[data-bbw2-next]')) return feed.scrollBy({ top: feed.clientHeight, behavior: 'smooth' });
      const sl = t.closest('[data-bbw2-sl]');
      if (sl && !t.closest('.bbw2-pbar, .bbw2-rail, .bbw2-top, a, button')) {
        const c = ctrls.get(sl);
        if (c && c.step) { const r = sl.getBoundingClientRect(); c.step(e.clientX - r.left > r.width / 2 ? 1 : -1); return; }
        togglePause(sl);
      }
    });
    document.addEventListener('keydown', (e) => {
      if (H.classList.contains('bbcod-open')) return; // the COD order form (bb-cod.js) is on top
      if (e.key === 'Escape') { if (H.classList.contains('bbw2-qb')) return closeQ(); if (pl.classList.contains('is-on')) return close(); }
      if (!pl.classList.contains('is-on') || H.classList.contains('bbw2-qb')) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); feed.scrollBy({ top: feed.clientHeight, behavior: 'smooth' }); }
      if (e.key === 'ArrowUp') { e.preventDefault(); feed.scrollBy({ top: -feed.clientHeight, behavior: 'smooth' }); }
      const onCtl = e.target && e.target.closest && e.target.closest('button, a, input, textarea');
      if (e.key === ' ' && active && !onCtl) { e.preventDefault(); togglePause(active); }
      if ((e.key === 'm' || e.key === 'M') && !onCtl) setMuted(!(muted || policyMuted));
    });
    /* keep the current video aligned when the screen size changes (entering / leaving full screen, rotation) */
    const realign = () => { if (!active || !pl.classList.contains('is-on')) return; const i = slides().indexOf(active); if (i > -1) feed.scrollTop = i * feed.clientHeight; };
    window.addEventListener('resize', () => requestAnimationFrame(realign));
    document.addEventListener('fullscreenchange', () => requestAnimationFrame(realign));
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
